import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/admin/securitate")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/setari", search: { tab: "securitate" } });
  },
  component: () => null,
});
